import { Outlet } from "react-router-dom"
import StyledContainer from "style/styledContainer"
import styled from "styled-components"
import LeftBarCom from "./components/pc/LeftBarCom"

const BaseLayout = () => {
    return <BaseLayoutWrap>
        <LeftBarCom></LeftBarCom>
        <MainWrap>
            <Outlet></Outlet>
        </MainWrap>
    </BaseLayoutWrap>
}


const BaseLayoutWrap = styled(StyledContainer)`
    display: flex;
    align-items: stretch;
    background-color: ${({theme}) => theme.basicGrey}
`

const MainWrap = styled(StyledContainer)`
    flex: 1;
    display: flex;
`  

export default BaseLayout